export const getTenantWithEnv = (
  tenant: string,
  coreShopEnvironment: string
) => {
  return coreShopEnvironment === 'prod'
    ? tenant
    : `${tenant}-${coreShopEnvironment}`
}
